<template>
	<div>
		<pt-sub-title title="发票">
		<el-button type="text" icon="el-icon-refresh" @click="invoiceSynchronization" :class="$style['syn-button']" :loading="synchroLoading">同步</el-button>
		</pt-sub-title>
		<el-alert title="注：CPS同步发票后如果数据不全，则需要CPS系统内先录入发票" type="warning"
    description="" show-icon>
    </el-alert>
     <wt-table :list="tableData" :labels="tableLabels" :class="$style['life-invoice-table']" :loading="loading">
			<el-table-column label="操作">
				<template slot-scope="scope">
				<el-button type="text" @click="viewInvoice(scope.row.ossUrl)">查看发票</el-button>
			</template>
			</el-table-column>
		</wt-table>
		<template v-if="synTableData&&synTableData.length">
		<pt-sub-title title="CPS同步发票"></pt-sub-title>
		<wt-table :list="synTableData" :labels="tableLabels" :class="$style['life-invoice-table']">
			<el-table-column label="操作">
				<!-- <template slot-scope="scope">
				<el-button type="text" @click="viewInvoice(scope.row.ossUrl)">查看发票</el-button>
			</template> -->
			</el-table-column>
		</wt-table>
	</template>
	</div>
</template>
<script>
import api from '@/api'
import {customerInvoiceTableLabels} from "./customer-detail-option"
export default {
	props:{
		userLogin:String
	},
	data(){
		return{
			loading:false,
			tableData:[],
			tableLabels:customerInvoiceTableLabels,
			synchroLoading:false,
			synTableData:[]
		}
	},
	methods:{
		getInvoiceList(){
			this.loading=true
			this.$store.dispatch('getInvoiceList',this.userLogin).then(res=>{
				this.tableData=res
				this.loading=false
			}).catch(err=>{
				this.loading=false
				this.$message.err(err||'获取发票列表失败')
			})
		},
		viewInvoice(ossUrl){
      this.$http.get(api.api_server + '/formerop/api/invoice/down?ossUrl=' + ossUrl).then(url => {
				location.href=url.data
				// window.open(url.data)
      }).catch(err => {
        console.error(err)
      })
		},
		invoiceSynchronization(){
			this.synchroLoading=true
			this.$store.dispatch('getInvoiceSyn',this.userLogin).then(res=>{
				this.synchroLoading=false
				this.synTableData=res
				this.$message.success('同步成功')
			}).catch(err=>{
				this.synchroLoading=false
				this.$message.error(err||'同步失败')
			})
		}
	},
	created(){
		this.getInvoiceList()
	}
}
</script>
<style module lang="less">
.life-invoice-table{
	
}
.syn-button{
	padding: 0!important;
}
</style>